export default "__VITE_ASSET__mTyoAX24__"